/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const chain_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m9.423 17.913-.912.865A4.524 4.524 0 0 1 5.4 20a4.524 4.524 0 0 1-3.111-1.222A4.068 4.068 0 0 1 1 15.826c0-1.107.464-2.168 1.289-2.95l4.667-4.429a4.515 4.515 0 0 1 2.938-1.222 4.551 4.551 0 0 1 3.033.996 4.115 4.115 0 0 1 1.513 2.684 4.014 4.014 0 0 1-.811 2.945m1.126-7.932.734-.696A4.524 4.524 0 0 1 18.6 4c1.167 0 2.286.44 3.111 1.222A4.068 4.068 0 0 1 23 8.174a4.068 4.068 0 0 1-1.289 2.95l-4.667 4.428a4.516 4.516 0 0 1-2.939 1.221 4.551 4.551 0 0 1-3.031-.996 4.115 4.115 0 0 1-1.513-2.684 4.014 4.014 0 0 1 .811-2.945"
    />
  </svg>
)
export default chain_medium
